import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import ArrowIcon from '../../assets/images/catalogue/arrowIcon';
import ChargerModule from '../../components/chargerModule/ChargerModule';
import UserAccountDetails from './UserAccountTab1/UserAccountDetails';
import './UserAccount.scss';

interface IUserAccountTab {
  tabId: number;
  tabName: string;
}

const UserAccount: React.FC = () => {
  const history = useHistory();

  const [selectedTabId, setSelectedTabId] = useState<number>(0);

  const headerInfo = {
    title: 'Cuenta',
    subtitle: ''
  };

  const tabsList: IUserAccountTab[] = [
    {
      tabId: 0,
      tabName: 'General'
    }
  ];

  const handleBackClick = () => {
    if (history?.length) return history.goBack();
    return history.push('/dashboard');
  };

  const renderTabContent = () => {
    switch (selectedTabId) {
      case 0:
        return <UserAccountDetails />;
      default:
        return null;
    }
  };

  return (
    <ChargerModule headerInfo={headerInfo}>
      <div className="backButton" onClick={handleBackClick}>
        <ArrowIcon fill="#070F21" />
      </div>
      <div className="userAccount">
        <div className="tabsContainer">
          {tabsList.map(tab => (
            <div
              key={tab.tabId}
              onClick={() => setSelectedTabId(tab.tabId)}
              className={`tab ${selectedTabId === tab.tabId ? 'selected' : ''}`}
            >
              <div className="tabName">{tab.tabName}</div>
            </div>
          ))}
        </div>
        <div className="tabContent">{renderTabContent()}</div>
      </div>
    </ChargerModule>
  );
};

export default UserAccount;
